<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('potentialCustomers.potentialCustomersLabel') }}</span>
        <h3 class="page-title">{{ $t('potentialCustomers.potentialCustomerView') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/potencjalni-klienci')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('ui.backToList') }}
        </d-button>

        <d-button
          v-if="!customer_exists"
          theme="success"
          @click.prevent="$router.push('/klienci/nowy/z-potencjalnego-klienta/' + parseInt($route.params.id, 10))"
          class="mr-1">
          <i class="material-icons">add</i>
          {{ $t('potentialCustomers.createCustomerFromPotentialCustomer') }}
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs v-sticky-tabs card>
          <!-- Dane ogólne -->
          <d-tab
            :title="$t('ui.generalInfo')"
            active>
            <h4 class="mb-3 pb-3 border-bottom">
              {{ $t('ui.generalInfo') }}
            </h4>

            <div class="form-group">
              <label for="name" class="d-block">
                {{ $t('ui.name') }}:
              </label>

              {{ name }}
            </div>

            <div class="form-group">
              <label for="name" class="d-block">
                {{ $t('ui.emailAddress') }}:
              </label>

              {{ email }}
            </div>

            <div class="form-group">
              <label for="name" class="d-block">
                {{ $t('customer.telephone') }}:
              </label>

              {{ phone }}
            </div>

            <div class="form-group">
              <label for="name" class="d-block">
                {{ $t('potentialCustomers.activityStartAt') }}:
              </label>

              {{ activity_start_at }}
            </div>

            <div class="form-group">
              <label for="name" class="d-block">
                {{ $t('potentialCustomers.taxNumber') }}:
              </label>

              {{ tax_number }}
            </div>

            <div class="form-group">
              <label for="name" class="d-block">
                {{ $t('potentialCustomers.address') }}:
              </label>

              <template v-if="city || postcode">
                {{ city }} {{ postcode }}<br>
              </template>

              <template v-if="street || building || locale">
                {{ street }} {{ building }}
                <template v-if="locale"> / {{ locale }}</template>
              </template>
            </div>

            <div v-if="!loaded" class="pb-3 pt-3 text-center">
              {{ $t('ui.dataLoading') }}&hellip;
            </div>

            <d-alert
              v-if="loadError"
              show
              theme="warning">
              {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
            </d-alert>
          </d-tab>

          <d-tab :title="$t('potentialCustomers.contacts')">
            <contacts
              :contacts="contacts"
              :potentialCustomerID="parseInt(this.$route.params.id, 10)" />
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import Contacts from './Contacts.vue';
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'potential-customer',
  components: {
    'contacts': Contacts
  },
  data () {
    return {
      id: 0,
      name: '',
      email: '',
      phone: '',
      activity_start_at: '',
      contacts: [],
      tax_number: '',
      postcode: '',
      city: '',
      street: '',
      building: '',
      locale: '',
      customer_exists: false,
      // flags
      loaded: false,
      loadError: false
    };
  },
  mounted () {
    this.loadData();
    this.$bus.$on('potential-customer-contacts-reload-needed', this.loadContacts);
  },
  methods: {
    loadData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/potential-customers/item/',
        instanceFields: ['name', 'activity_start_at', 'email', 'phone', 'contacts', 'tax_number', 'postcode', 'city', 'street', 'building', 'locale', 'customer_exists'],
        params: {
          with: ['contacts']
        },
        loadedKey: 'loaded'
      });
    },
    loadContacts () {
      this.loaded = false;

      FormUtils.loadItemData(this, {
        endpointBase: '/potential-customers/item/',
        instanceFields: ['contacts'],
        params: {
          with: ['contacts']
        },
        loadedKey: 'loaded'
      });
    }
  },
  beforeDestroy () {
    this.$bus.$off('potential-customer-contacts-reload-needed', this.loadContacts);
  }
};
</script>
